import React from "react";

import Chart from "react-apexcharts";

import { areaChartConfig, CHART_COLORS } from "../../../utils/chartConfigs";
import EmptyState from "../shared/EmptyState";

/**
 * Revenue trending area chart with optional comparison overlay and target line.
 *
 * @param {{
 *   currentData: number[],
 *   previousData?: number[],
 *   categories: string[],
 *   height?: number,
 *   showComparison?: boolean,
 *   targetLine?: number
 * }} props
 */
const RevenueTrendChart = ({
  currentData,
  previousData,
  categories,
  height,
  showComparison,
  targetLine,
}) => {
  if (!currentData || currentData.length === 0) {
    return <EmptyState message="No revenue trend data available" />;
  }

  // Build series
  const series = [{ name: "Revenue", data: currentData }];
  const hasPrevious = previousData && previousData.length > 0;

  if (showComparison && hasPrevious) {
    series.push({ name: "Previous Period", data: previousData });
  }

  // Get base area config
  const config = areaChartConfig(series, categories);

  // If comparison, apply dashed stroke + reduced opacity for second series
  if (showComparison && hasPrevious) {
    config.stroke = {
      ...config.stroke,
      width: [2, 2],
      dashArray: [0, 5],
    };
    config.fill = {
      ...config.fill,
      opacity: [0.45, 0.1],
    };
    config.colors = [CHART_COLORS.primary, CHART_COLORS.gray];
  }

  // Add horizontal target annotation line
  if (targetLine !== undefined && targetLine !== null) {
    config.annotations = {
      ...config.annotations,
      yaxis: [
        {
          y: targetLine,
          borderColor: "#10b981",
          strokeDashArray: 4,
          label: {
            text: "Target",
            position: "left",
            style: {
              color: "#fff",
              background: "#10b981",
              fontSize: "12px",
              fontWeight: 600,
              padding: { left: 8, right: 8, top: 4, bottom: 4 },
            },
          },
        },
      ],
    };
  }

  // Separate series from options
  const { series: _series, ...options } = config;

  return (
    <Chart
      height={height || 350}
      options={options}
      series={series}
      type="area"
    />
  );
};

export default RevenueTrendChart;
